<template>
  <VRow>
    <VCol cols="12">
      {{ $t('interviewAborted') }} <a @click="reload">{{ $t('continue') }}</a>
    </VCol>
  </VRow>
</template>

<script>
export default {
  name: 'InterviewInterrupted',
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  interviewAborted: >-
    Unfortunately, the interview has stopped because you answered for too long. Refresh the page,
    and the interview will continue from where you stopped.
  continue: Continue
</i18n>

<i18n locale="ru" lang="yaml">
  interviewAborted: >-
    К сожалению интервью было прервано, т.к. вы отвечали на вопрос слишком долго.
    Обновите страницу и интервью будет продолжено с последнего вопроса.
  continue: Продолжить интервью
</i18n>
